// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"MembersListForManager_Wrapper__1R3pi"};